
import clientAxios from "../../client";

import { formatQueryString } from "@/common/utils/common";

import type { QueryType } from "@/common/types/common";

export async function gameTagList(
    game_id: string,
    query?: QueryType
) {
    const queryString = formatQueryString(query);

    return await clientAxios.get(
        `admin/game/${game_id}/tag/list${queryString}`
    );
}

export async function gameTagGet(
    item_id: string
) {
    return await clientAxios.get(
        `admin/game/tag/${item_id}/show`
    );
}

export async function gameTagCreate(
    game_id: string,
    tag_id: string
) {
    return await clientAxios.post(
        `admin/game/${game_id}/tag/create`,
        { tag_id }
    );
}

export async function gameTagDel(
    item_id: string,
) {
    return await clientAxios.del(
        `admin/game/tag/${item_id}/delete`,
    );
}
